import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { projects } from '../../data/projects';
import { equipment } from '../../data/equipment';
import { images } from '../../data/images';
import type { SiteImage } from '../../types/content';
interface Panel {
  to: string;
  title: string;
  figure: string;
  unit: string;
  text: string;
  image: SiteImage;
  large?: boolean;
}
const panels: Panel[] = [{
  to: '/projects',
  title: 'Projects',
  figure: String(projects.length),
  unit: 'documented project records',
  text: 'Roads, water and sanitation, mining earthworks, buildings and maintenance for public and private clients.',
  image: images.culvert,
  large: true
}, {
  to: '/plant-equipment',
  title: 'Plant & Equipment',
  figure: String(equipment.length),
  unit: 'equipment lines in the plant schedule',
  text: 'From graders and rollers to tipper trucks and scaffolding.',
  image: images.tipperTrucks
}, {
  to: '/about/company-background',
  title: 'About Us',
  figure: '2007',
  unit: 'year of incorporation',
  text: 'Citizen-owned and based in Gaborone, with engineers and project and site managers.',
  image: images.surveyor
}];
export function CapabilityLinks() {
  return <section aria-labelledby="capability-title" className="bg-charcoal-950 py-20 md:py-28" data-id="element-117" data-mp="2r7rqpr49r405">
      <div className="mx-auto max-w-site px-5 md:px-8" data-id="element-118" data-mp="360lh47l2x4jl">
        <SectionHeading id="capability-title" label="Capability" title="Company capability at a glance" className="max-w-2xl" data-id="element-119" data-mp="30ycmz7wgzwfw" />
        <div className="mt-12 grid gap-4 lg:grid-cols-[1.35fr_1fr] lg:grid-rows-2" data-id="element-120" data-mp="3eydxzg6g8k93">
          {panels.map(panel => <Link key={panel.to} to={panel.to} className={`group relative isolate flex min-h-[300px] flex-col justify-end overflow-hidden p-7 md:p-9 ${panel.large ? 'lg:row-span-2 lg:min-h-[620px]' : ''}`} data-id="element-121" data-mp="39y9i9sdd7tjx">
              <img src={panel.image.src} alt="" loading="lazy" decoding="async" className="absolute inset-0 -z-20 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-122" data-mp="3fqng2i1k9tl7" />
              <div className="absolute inset-0 -z-10 bg-charcoal-950/70" aria-hidden="true" data-id="element-123" data-mp="3tlr09472gqu3" />
              <p className={`font-display font-extrabold leading-none text-white ${panel.large ? 'text-[96px] md:text-[120px]' : 'text-[64px]'}`} data-id="element-124" data-mp="2fy5yymchmox">
                {panel.figure}
              </p>
              <p className="mt-1 text-[14px] font-semibold uppercase tracking-[0.14em] text-steel-200" data-id="element-125" data-mp="c9y7kqif49sw">{panel.unit}</p>
              <div className="mt-6 flex items-end justify-between gap-6 border-t border-white/25 pt-5" data-id="element-126" data-mp="l8jypa1ygx5a">
                <div data-id="element-127" data-mp="q73knagju8xn">
                  <h3 className="font-display text-[28px] font-bold uppercase leading-none text-white" data-id="element-128" data-mp="q8epldlqdmqc">{panel.title}</h3>
                  <p className="mt-2 max-w-md text-[15px] leading-relaxed text-steel-200" data-id="element-129" data-mp="2aqz0ay7x5rzu">{panel.text}</p>
                </div>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-brand-action text-white transition-colors duration-150 group-hover:bg-brand-action-hover" data-id="element-130" data-mp="25snpol9svdgk">
                  <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="1wrh6u5johqk5" />
                </span>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}